import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/Button';
import Card, { CardBody } from '../components/Card';
import { useAuth } from '../context/AuthContext';
import { UserIcon, LockIcon, AlertCircleIcon } from 'lucide-react';
import LoginCredentialsHelper from '../components/LoginCredentialsHelper';
const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleCredentialSelect = (selectedEmail: string, selectedPassword: string) => {
    setEmail(selectedEmail);
    setPassword(selectedPassword);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    setIsLoading(true);
    try {
      await login(email, password);
      // If login doesn't throw an error, it was successful
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-5493">
      <Header data-id="element-5494" />
      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-5495">
        <div className="max-w-md w-full" data-id="element-5496">
          <div className="text-center mb-8" data-id="element-5497">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-5498">
              Sign in to your account
            </h1>
            <p className="mt-2 text-gray-600" data-id="element-5499">
              Access all Edo State government services in one place
            </p>
          </div>
          <Card data-id="element-5500">
            <CardBody data-id="element-5501">
              {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md flex items-center" data-id="element-5502">
                  <AlertCircleIcon className="h-5 w-5 mr-2" data-id="element-5503" />
                  <span data-id="element-5504">{error}</span>
                </div>}
              <form onSubmit={handleSubmit} data-id="element-5505">
                <div className="mb-4" data-id="element-5506">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-5507">
                    Email Address
                  </label>
                  <div className="relative" data-id="element-5508">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-5509">
                      <UserIcon className="h-5 w-5 text-gray-400" data-id="element-5510" />
                    </div>
                    <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-500 focus:border-green-500" placeholder="Enter your email" data-id="element-5511" />
                  </div>
                </div>
                <div className="mb-6" data-id="element-5512">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-5513">
                    Password
                  </label>
                  <div className="relative" data-id="element-5514">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-5515">
                      <LockIcon className="h-5 w-5 text-gray-400" data-id="element-5516" />
                    </div>
                    <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-500 focus:border-green-500" placeholder="Enter your password" data-id="element-5517" />
                  </div>
                </div>
                <div className="flex items-center justify-between mb-6" data-id="element-5518">
                  <div className="flex items-center" data-id="element-5519">
                    <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" data-id="element-5520" />
                    <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-5521">
                      Remember me
                    </label>
                  </div>
                  <div className="text-sm" data-id="element-5522">
                    <a href="#" className="font-medium text-green-600 hover:text-green-500" data-id="element-5523">
                      Forgot your password?
                    </a>
                  </div>
                </div>
                <Button type="submit" variant="primary" fullWidth disabled={isLoading} data-id="element-5524">
                  {isLoading ? 'Signing in...' : 'Sign in'}
                </Button>
              </form>
              {/* Demo credentials helper */}
              <LoginCredentialsHelper onSelectCredential={handleCredentialSelect} data-id="element-5525" />
              <div className="mt-6 text-center" data-id="element-5526">
                <p className="text-sm text-gray-600" data-id="element-5527">
                  Don't have an account?{' '}
                  <Link to="/register" className="font-medium text-green-600 hover:text-green-500" data-id="element-5528">
                    Register now
                  </Link>
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
      </main>
      <Footer data-id="element-5529" />
    </div>;
};
export default LoginPage;